const INITIAL_STATE = {
  data: {},
  errors: {},
};
const getRoles = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "GET_USER_ROLES_SUCCESSFULLY":
    return { ...INITIAL_STATE, data: action.data };
  case "GET_USER_ROLES_FAILED":
    return { ...INITIAL_STATE, errors: action.data };
  default:
    return { ...state };
  }
};

export default getRoles;
